import { Link } from "react-router-dom";

function TeamSection() {
  return (
    <section id="team" className="bg-white text-deepgreen px-6 py-24 border-t border-gray-100">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4" data-aos="fade-up">
          Meet Our Team
        </h2>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-12" data-aos="fade-up" data-aos-delay="100">
          Led by dedicated professionals who uphold the firm’s mission of professionalism, humility, and integrity.
        </p>

        <div className="grid gap-8 sm:grid-cols-1 md:grid-cols-3 text-center">
          <div className="bg-white p-8 rounded-xl shadow-lg border border-gray-100 hover:-translate-y-2 transition-transform duration-300" data-aos="fade-up">
            <img
              src="/team/odira.jpeg"
              alt="Elvis Nanda"
              className="w-20 h-20 mx-auto object-cover object-top rounded-full mb-6"
            />
            <h3 className="text-xl font-serif font-bold mb-2">Elvis Nanda</h3>
            <p className="text-gold font-medium mb-4 uppercase text-sm tracking-wide">Managing Partner</p>
            <p className="text-gray-600 text-sm leading-relaxed">
              With extensive experience in litigation and constitutional law, Elvis leads the firm with vision, integrity, and unmatched advocacy.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-lg border border-gray-100 hover:-translate-y-2 transition-transform duration-300" data-aos="fade-up" data-aos-delay="100">
            <img
              src="/team/weke.jpeg"
              alt="Mary Weke"
              className="w-20 h-20 mx-auto object-cover object-top rounded-full mb-6"
            />
            <h3 className="text-xl font-serif font-bold mb-2">Mary Weke</h3>
            <p className="text-gold font-medium mb-4 uppercase text-sm tracking-wide">Senior Partner</p>
            <p className="text-gray-600 text-sm leading-relaxed">
              Mary specializes in corporate law and conveyancing, offering strategic guidance to businesses and property clients alike.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-lg border border-gray-100 hover:-translate-y-2 transition-transform duration-300" data-aos="fade-up" data-aos-delay="200">
            <div className="w-20 h-20 mx-auto bg-gray-100 text-deepgreen rounded-full mb-6 flex items-center justify-center text-2xl font-serif font-bold">ST</div>
            <h3 className="text-xl font-serif font-bold mb-2">Support Team</h3>
            <p className="text-gold font-medium mb-4 uppercase text-sm tracking-wide">Operations</p>
            <p className="text-gray-600 text-sm leading-relaxed">
              A dedicated team ensuring smooth case handling, scheduling, and reliable communication throughout your legal journey.
            </p>
          </div>
        </div>

        <div className="mt-12" data-aos="fade-up" data-aos-delay="300">
          <Link to="/team" className="inline-block border-2 border-deepgreen text-deepgreen font-bold py-3 px-8 rounded-full hover:bg-deepgreen hover:text-white transition duration-300">
            View Full Team
          </Link>
        </div>
      </div>
    </section>
  );
}

export default TeamSection;
